import { useState } from 'react'
import { Tabs } from '../../../../components/Tabs/Tabs'
import { CRMIntegrationSettings } from '../CRMIntegrationSettings'
import { ContactSyncSettings } from '../ContactSyncSettings'
import { CRMIntegrationTaskSettings } from '../CRMIntegrationTaskSettings'
import { Modal } from '../../../../components/Modal/Modal'
import { Modal as BootstrapModal, Tab } from 'react-bootstrap'

export type ElementsSettingsModalProps = {
  show: boolean
  onHide: () => void
}

export const ElementsSettingsModal: React.FC<ElementsSettingsModalProps> = ({ show, onHide }) => {
  const [activeTabKey, setActiveTabKey] = useState<string>('elementsMappings')
  const changeTab = (key: string | null): void => {
    if (key) {
      setActiveTabKey(key)
    }
  }

  const ElementsSettingsModalBody = () => {
    return (
      <Tabs activeKey={activeTabKey} id='elements-settings' className='d-flex mb-3' onSelect={changeTab} mountOnEnter unmountOnExit>
        <Tab eventKey='elementsMappings' title='Mappings'>
          <CRMIntegrationSettings serviceId='elements' onSaved={onHide} onCancelled={onHide} />
        </Tab>
        <Tab eventKey='elementsSyncSettings' title='Contact Sync'>
          <ContactSyncSettings serviceId={'elements'} />
        </Tab>
        <Tab eventKey='elementsTaskSettings' title='Tasks'>
          <CRMIntegrationTaskSettings serviceId='elements' />
        </Tab>
      </Tabs>
    )
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<BootstrapModal.Title>Edit SS&C BlackDiamond Elements Integration Settings</BootstrapModal.Title>}
      body={<ElementsSettingsModalBody />}
    />
  )
}
